var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaw = function SvgPaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 15,
    fill: "#FC4CDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paw_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.88 29.69a5.577 5.577 0 0 0-4.716-2.579c-1.917 0-3.68.964-4.715 2.579l-2.494 3.89a3.521 3.521 0 0 0-.552 2.156c.053.765.344 1.478.842 2.061a3.522 3.522 0 0 0 1.905 1.152 3.52 3.52 0 0 0 2.216-.21l.047-.022a6.968 6.968 0 0 1 5.549.021 3.524 3.524 0 0 0 2.216.211 3.522 3.522 0 0 0 1.905-1.152 3.52 3.52 0 0 0 .842-2.06 3.522 3.522 0 0 0-.552-2.157l-2.494-3.89ZM21.628 29.684c.742-.285 1.306-.882 1.587-1.683.268-.762.246-1.622-.062-2.422s-.868-1.453-1.578-1.839c-.745-.405-1.564-.47-2.305-.185-1.49.573-2.174 2.414-1.524 4.106.519 1.346 1.73 2.196 2.953 2.196.313 0 .626-.056.93-.172ZM26.464 26.637c1.863 0 3.379-1.727 3.379-3.85 0-2.122-1.516-3.85-3.379-3.85s-3.378 1.727-3.378 3.85 1.515 3.85 3.378 3.85ZM32.3 27.582c.287.095.58.14.87.14 1.36 0 2.683-.988 3.188-2.508.292-.874.272-1.8-.053-2.604-.341-.842-.973-1.454-1.779-1.721-.806-.268-1.678-.157-2.455.314-.743.45-1.311 1.179-1.602 2.054-.613 1.845.208 3.785 1.832 4.325ZM39.414 27.133c-1.285-.95-3.206-.538-4.283.917-1.076 1.456-.908 3.413.375 4.362.467.347 1.02.513 1.586.513.986 0 2.012-.504 2.697-1.43 1.076-1.455.908-3.412-.375-4.362Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paw_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.5 17.5)",
    d: "M0 0h23v23H0z"
  })))));
};
export default SvgPaw;